import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  FormHelperText,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import BodyWapperUI from "../../common/BodyWapperUI";
import AppbarUI from "../../common/AppbarUI";
import DrawerUI from "../../common/DrawerUI";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { set, useForm } from "react-hook-form";
import { uplodImageAction } from "../../redux/toolkit/image/uploadImage";
import Avatar from "@mui/material/Avatar";
import { display, Stack, width } from "@mui/system";
import { myProfileAction } from "../../redux/toolkit/profile/my-profile";
import { editProfileAction } from "../../redux/toolkit/profile/edit";
import SnackUI from "../../common/SnackUI";

const profile_schema = yup
  .object()
  .shape({
    name: yup.string().required("Name is Required"),
    profile_img: yup.string().required("Profile Image is Required."),
    tax_id: yup.string().required("Tax Id is Required"),
    companyName: yup.string().required("Company is Required"),
    street_name: yup.string().required("Street Name is Required"),
    street_no: yup.string().required("Street No is Required"),
    city: yup.string().required("City is Required"),
    country: yup.string().required("Country is Required"),
    skypeId: yup.string().required("Skype Id is Required"),
    phoneNumber: yup
      .string()
      .typeError("Phone Number is Required")
      .required("Phone Number is Required"),
  })
  .required();

export default function Show() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [profileImg, setProfileImg] = useState();

  const myProfileSelector = useSelector((state) => state.myProfile);
  const { data: profileData } = myProfileSelector;
  const [showPopup, setShowPopup] = useState(false);

  const editProfile = useSelector((state) => state.editProfile);
  const { data, status, message } = editProfile;

  // console.log("status============== 66666666666666666666666666666666666666666=========>", status ,"message============>", message , "snow popup", showPopup);

  const {
    register,
    control,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(profile_schema),
    defaultValues: {},
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.name = profileData.name;
    defaultValues.tax_id = profileData.tax_id;
    defaultValues.companyName = profileData.companyName;
    defaultValues.address = profileData.address;
    defaultValues.street_name = profileData.street_name;
    defaultValues.street_no = profileData.street_no;
    defaultValues.country = profileData.country;
    defaultValues.phoneNumber = profileData.phoneNumber;
    defaultValues.skypeId = profileData.skypeId;
    defaultValues.city = profileData.city;
    defaultValues.profile_img = profileData.profile_img;
    // setPlatformVal(appData.platform)
    setProfileImg(profileData.profile_img);
    reset({ ...defaultValues });
  }, [profileData, dispatch]);

  const handleIconUpload = async (e) => {
    const formData = new FormData();

    formData.set("file", e.target.files[0]);

    let uploadedImg = await dispatch(uplodImageAction(formData));
    const imgStr = uploadedImg?.payload?.data?.url;
    setProfileImg(imgStr);
    setValue("profile_img", imgStr, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleAppSubmit = async (data) => {
    const appStore = await dispatch(
      editProfileAction({ profile_img: profileImg, ...data })
    );

    setShowPopup(true);
    dispatch(myProfileAction());
    navigate("/profile");
  };

  // const handleAppSubmit = async (data) => {
  //   await dispatch(editProfileAction({ profile_img: profileImg, ...data }));
  //   await dispatch(myProfileAction());
  //   navigate("/profile");
  // };

  // const handleClose = () => {
  //   // console.log("handleClose",state);
  //   setShowPopup(false);
  //   // clearTimeout(timeoutId);
  // };


  // useEffect(() => {
  //   console.log("66666666666666666666666666666666666666666=========>", status ,"message============>", message );
  //   if (status && message) {
  //     setShowPopup(true);
  //   }

  // }, [status, message]);

  return (
    <>
      <Helmet>
        <title> Survey Wall | Postback </title>
      </Helmet>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        <Card
          sx={{
            p: { xs: 2, sm: 4, md: 5 },
            border: "1px solid #000",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ mb: 5 }}>
              Customize Profile
            </Typography>
            <form onSubmit={handleSubmit(handleAppSubmit)}>
              <Stack spacing={4}>
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  useFlexGap
                  flexWrap={{ sx: "wrap", md: "nowrap" }}
                >
                  <TextField
                    label="Company Name"
                    InputLabelProps={{ shrink: true }}
                    {...register("companyName")}
                    error={Boolean(errors?.companyName)}
                    helperText={errors?.companyName?.message}
                    sx={{ width: { xs: "100%", sm: "600px", md: "600px" } }}
                  />
                  <TextField
                    label="Full Name"
                    InputLabelProps={{ shrink: true }}
                    {...register("name")}
                    error={Boolean(errors?.name)}
                    helperText={errors?.name?.message}
                    sx={{ width: { xs: "100%", sm: "600px", md: "600px" } }}
                  />
                </Stack>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  alignItems="center"
                  spacing={2}
                >
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Profile img"
                    type="file"
                    id="profile_img"
                    onChange={handleIconUpload}
                    error={Boolean(errors?.profile_img)}
                    helperText={errors?.profile_img?.message}
                    sx={{ width: { xs: "100%", sm: "500px", md: "500px" } }}
                  />
                  <Avatar
                    alt="Dp"
                    src={profileImg}
                    sx={{ width: 56, height: 56 }}
                  />
                </Stack>

                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  flexWrap={{ sx: "wrap", md: "nowrap" }}
                  useFlexGap
                >
                  <TextField
                    // fullWidth
                    label="Tax id"
                    InputLabelProps={{ shrink: true }}
                    {...register("tax_id")}
                    error={Boolean(errors?.tax_id)}
                    helperText={errors?.tax_id?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                  <TextField
                    // fullWidth
                    label="Street name"
                    InputLabelProps={{ shrink: true }}
                    {...register("street_name")}
                    error={Boolean(errors?.street_name)}
                    helperText={errors?.street_name?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                  <TextField
                    // fullWidth
                    label="Street no"
                    InputLabelProps={{ shrink: true }}
                    {...register("street_no")}
                    error={Boolean(errors?.street_no)}
                    helperText={errors?.street_no?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                </Stack>

                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  flexWrap={{ sx: "wrap", md: "nowrap" }}
                  useFlexGap
                >
                  <TextField
                    label="City"
                    InputLabelProps={{ shrink: true }}
                    {...register("city")}
                    error={Boolean(errors?.city)}
                    helperText={errors?.city?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                  <TextField
                    label="Country"
                    InputLabelProps={{ shrink: true }}
                    {...register("country")}
                    error={Boolean(errors?.country)}
                    helperText={errors?.country?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                  <TextField
                    label="Skype Id"
                    InputLabelProps={{ shrink: true }}
                    {...register("skypeId")}
                    error={Boolean(errors?.skypeId)}
                    helperText={errors?.skypeId?.message}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                </Stack>

                <Stack direction="row" spacing={2} flexWrap="wrap">
                  <TextField
                    // fullWidth
                    label="Phone Number"
                    InputLabelProps={{ shrink: true }}
                    {...register("phoneNumber")}
                    error={Boolean(errors?.phoneNumber)}
                    helperText={errors?.phoneNumber?.message}
                    // sx={{ maxWidth: 300 }}
                    sx={{ width: { xs: "100%", sm: "300px", md: "350px" } }}
                  />
                </Stack>

                <Stack direction="row" spacing={2} flexWrap="wrap">
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      width: { xs: "100%", sm: "300px", md: "350px" },
                      backgroundImage:
                        "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                      color: "#fff", // ensure text is readable on gradient
                    }}
                  >
                    Update profile
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Card>
      </BodyWapperUI>

      
        <SnackUI
          state={showPopup}
          setState={setShowPopup}
          status={status}
          message={message}
        />
    
    </>
  );
}
